import { render, staticRenderFns } from "./DocumentStatusHistory.vue?vue&type=template&id=82e875c4&scoped=true"
import script from "./DocumentStatusHistory.vue?vue&type=script&lang=js"
export * from "./DocumentStatusHistory.vue?vue&type=script&lang=js"
import style0 from "./DocumentStatusHistory.vue?vue&type=style&index=0&id=82e875c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e875c4",
  null
  
)

export default component.exports